import { el } from 'redom';

import NativeHorizontalToggle from 'generics/components/horizontal-toggle/native';

class RequiredInputRow {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    this.el = el('.required-input-row', {
      class: 'form-input-row'
    }, [
      new NativeHorizontalToggle({
        label: 'Required',
        value: configuration.checked === true,
        onChange: this.handleInputChange.bind(this)
      })
    ]);

  }

  handleInputChange(checked) {

    this.onChange(checked);

  }

}

export default RequiredInputRow;